<template>
  <div @click.prevent.stop="toggleState" style="cursor: pointer; white-space: nowrap;">
    <span>
      <font-awesome-icon
        v-tooltip="{ content: value ? tooltipShow : tooltipHide }"
        :icon="['fas', value ? 'eye' : 'eye-slash' ]"
        color="white"
        style="outline: 0; width: 32px" />
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    tooltipHide: {
      default: 'Click to show'
    },
    tooltipShow: {
      default: 'Click to hide'
    }
  },
  methods: {
    toggleState() {
      this.$emit('input', !this.value);
    }
  }
}
</script>
